module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/kimono/shiromuku-3bc2b20903811f930eb148db8d1957b9.jpg";